import React from 'react';
import { getMinutes } from '@shootsta/format-seconds';
import cx from 'classnames';
import TimestampLabel from '../../TimestampLabel';
import VisibilityDropdown from '../../../../../../VisibilityDropdown';
import { getContentState } from '../../../../../../../../RichTextEditor';
import { Text } from '../../../../../../../../../ui-kit';
import { parseJSON } from '../../../../../../../../../common/utils';
import EditComment from '../../EditComment';
import CommentAssets from '../../../../../../CommentAssets';

import '../styles/_comment-v2-body.scss';



















const CommentV2Body = ({
  commentIndex,
  comment,
  editorState,
  isShootstaUser,
  organisationName,
  isChildren,
  commentIdToEdit,
  onUpdateContent,
  onSave,
  toggleEditMode,
  allowedVisibilityOptions,
  onFilesChange,
  hideTimestamp,
  hideVisibility,
  isEditable
}) => {
  const { metadata, commentId, assetIds } = comment;
  const { plainText: commentText } = getContentState(editorState);
  const { timestamp, visibility, isRejected } = parseJSON(metadata) || {};
  const editMode = commentIdToEdit === commentId;

  return (
    <div
      className={cx('comment-v2-body', {
        'comment-v2-body--children': isChildren,
        'comment-v2-body--parent': !isChildren
      })}>

      {!editMode ?
      <div className="comment-v2-body__readonly">
          {!isChildren && timestamp !== null && timestamp !== undefined &&
        <TimestampLabel
          timestamp={getMinutes(timestamp)}
          visibility={visibility}
          isRejected={isRejected} />}


          {!isChildren && visibility &&
        <VisibilityDropdown
          id={`comment-v2-body-visibility-${commentIndex}`}
          allowedWriteVisibilityOptions={allowedVisibilityOptions}
          value={visibility}
          isShootstaUser={isShootstaUser}
          organisationName={organisationName} />}


          <Text className="comment-v2-body__readonly--comment">
            {commentText}
          </Text>
          <CommentAssets
          isV2Design
          assetIds={assetIds}
          commentId={commentId}
          canDelete={isEditable} // project owner or comment author can delete assets
          onFilesChange={onFilesChange} />

        </div> :

      <div className="comment-v2-body__edit-mode">
          <EditComment
          comment={comment}
          editorState={editorState}
          onUpdateContent={onUpdateContent}
          onSave={onSave}
          toggleEditMode={toggleEditMode}
          onFilesChange={onFilesChange}
          hideTimestamp={hideTimestamp}
          hideVisibility={hideVisibility} />

        </div>}

    </div>);

};

export default CommentV2Body;